import React from 'react';

const NotFound = (props) => {
  return (
    <div id="message" className="container not-found">
      <div className="content">
        <h2>404 Page Not Found</h2>
        <h3>OOPS SOMETHING WENT WRONG!</h3>
        <p>WE CAN'T SEEM TO FIND THE SECTION YOU ARE LOOKING FOR</p>
        <a href="/">Click here to go to home section.</a>
      </div>
    </div>
  );
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js